"use client";

import { useLocale } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { usePathname } from 'next/navigation';

export default function FooterLanguageSwitcher() {
	const locale = useLocale();
	const pathname = usePathname(); // current route path

	const getLocaleAgnosticPath = (currentPathname: string, currentLocale: string) => {
		const localePrefix = `/${currentLocale}`;
		if (currentPathname.startsWith(localePrefix)) {
			// Ensure that if the path is just "/en", it becomes "/"
			return currentPathname.substring(localePrefix.length) || '/';
		}
		return currentPathname;
	};

	const localeAgnosticPath = getLocaleAgnosticPath(pathname, locale);

	return (
		<div className="flex gap-4">
			<Link
				href={localeAgnosticPath}
				locale="ru"
				className={locale === "ru" ? "text-white font-bold" : "hover:text-white"}
			>
				Русский
			</Link>

			<span>|</span>

			<Link
				href={localeAgnosticPath}
				locale="en"
				className={locale === "en" ? "text-white font-bold" : "hover:text-white"}
			>
				English
			</Link>
		</div>
	);
}
